export default __webpack_public_path__ + "static/media/page_break_element.bb342ab5.svg";